import React, { useState, useEffect } from "react";
import Image from "next/legacy/image";
import { useRecoilState, useRecoilValue } from "recoil";
import { evaluationAtom } from "@_recoil/_state";
import Skeleton from "@mui/material/Skeleton";
import Box from "@mui/material/Box";
import { swalError } from "@unisearch/helpers";
import { getAssets } from "@unisearch/helpers";
import styles from "./evaluation_country.module.scss";

const EvaluationCountry = () => {
  const { countrylist, is_loading } = useRecoilValue(evaluationAtom);

  const [{ countryPreference }, setCountryPreference] = useRecoilState(
    evaluationAtom
  );

  const handleCounty = (event) => {
    //get target value
    const { value, checked } = event.target;

    //when unchecked remove form selected
    if (!checked) {
      setCountryPreference((prev) => ({
        ...prev,
        countryPreference: countryPreference.filter(
          (countryId) => countryId != value
        ),
      }));
      return false;
    }

    //checked store max 3 coutnries
    if (countryPreference.length >= 3) {
      swalError("You can select max 3 countries");
      return false;
    }

    if (checked) {
      setCountryPreference((prev) => ({
        ...prev,
        countryPreference: [...prev.countryPreference, parseInt(value)],
      }));
    }
  };

  useEffect(() => {
    setCountryPreference((prev) => ({
      ...prev,
      formStape: 1,
    }));
  }, []);

  useEffect(() => {
    setCountryPreference((prev) => ({
      ...prev,
      show_next: countryPreference.length >= 1 ? true : false,
    }));
  }, [countryPreference]);

  return (
    <>
      <div className={styles.title_wrapper}>
        <div className={styles.title}>
          What is Your Preferred Country for Admission?
        </div>
      </div>
      <div className={styles.content}>
        <ul>
          {(is_loading ? Array.from(new Array(5)) : countrylist).map(
            (country, index) => {
              if (country) {
                return (
                  <li key={`${country.countryId}_${country.name}`}>
                    <label
                      htmlFor={country.countryId}
                      className={
                        countryPreference.includes(parseInt(country.countryId))
                          ? styles.checked
                          : ""
                      }
                    >
                      <input
                        style={{ display: "none" }}
                        type="checkbox"
                        id={country.countryId}
                        name="country"
                        value={country.countryId}
                        checked={
                          countryPreference.includes(
                            parseInt(country.countryId)
                          )
                            ? true
                            : false
                        }
                        onChange={handleCounty}
                      />
                      <div className={styles.country_flag_wrapper}>
                        <img
                          width={136}
                          height={100}
                          src={
                            country?.flagImage?.src ||
                            getAssets("assets/images/flag-placeholder.jpg")
                          }
                          alt={country?.name}
                        />
                        <div className={styles.country_name}>
                          {country?.name}
                        </div>
                      </div>
                    </label>
                  </li>
                );
              } else {
                return (
                  <Box sx={{ pt: 0.5 }} key={`${index}_${Math.random()}`}>
                    <Skeleton variant="rectangular" width={200} height={118} />
                    <Skeleton />
                  </Box>
                );
              }
            }
          )}
        </ul>
      </div>
    </>
  );
};

export default EvaluationCountry;
